module.exports = "<md-card>\n    <md-card-content>\n        <h1>Page Not Found</h1>\n            <p>The page or URL path you are looking for does not exist.</p>\n    </md-card-content>\n</md-card>"


//////////////////
// WEBPACK FOOTER
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/templates/error/page-not-found.component.html
// module id = ../../../../../src/app/assets/templates/error/page-not-found.component.html
// module chunks = main